import { isAppWebView, patchWhenReady } from "./ucBannerSuppressor.js";

if (isAppWebView()) {
	patchWhenReady();
}
